import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment'
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Subject, Observable, ReplaySubject, from } from 'rxjs';
import { StmgService } from '../../services/state_Management/stmg.service';
import { BaseServiceService } from '../base_service/base-service.service';

@Injectable({
  providedIn: 'root'
})
export class CmsServiceService {

  //Url: string = environment.baseUrl;
  Url: string ;

  // temporarily added for news service
  //TempUrl = 'https://www.stbet.com/'; 
  //TempUrl = 'https://testmobile2.stbet.com/';

  constructor(
    private http: HttpClient,
    private state: StmgService,
    public baseService:BaseServiceService
  ) {

    this.Url=baseService.envUrl();

    switch(this.Url){
      case "https://testmobile.stbet.com":
        this.Url = "https://cms.stbet.com";
        break;
    }
 
    // switch(environment.production){
    //   case false: 
    //   this.Url = this.Url;
    //   break;
    //   case true: 
    //   this.Url = this.Url
    //   break;
    // }

  }

  getCmsNews() {
    return this.Url + '/stbetwebcms/?json=get_posts&post_type=news_banners';
  }

  getCmsCategories(): Observable<any> {
    const url_user = this.Url + '/stbetwebcms/?json=get_categories';
    const params_getUser = new HttpParams()
    const responseObservable = this.http.get(url_user, {
      responseType: 'json',
      params: params_getUser,
      headers: new HttpHeaders()
    })
    responseObservable.subscribe(categories => this.state.updateNewsCategories(categories))
    return responseObservable
  }

  getCmsPosts() {
    //const url_user = this.TempUrl + 'stbetwebcms/?json=get_posts';
    const url_user = this.Url + '/stbetwebcms/?json=get_all_posts';
    const params_getUser = new HttpParams()
    const responseObservable = this.http.get(url_user, {
      responseType: 'json',
      params: params_getUser,
      headers: new HttpHeaders()
    })
    responseObservable.subscribe(info => {
      this.state.updateNewsInfo(info);
      //console.log(info);
    })
    return responseObservable
  }

  getCategoryPosts(data: any) : Observable<any> {
    const url_user = this.Url + '/stbetwebcms/';
    const params_getUser = new HttpParams()
    .set('json', "get_category_posts")
    .set('id', data.term_id)
    const responseObservable = this.http.get(url_user, {
      params: params_getUser,
      headers: new HttpHeaders()
    })
    responseObservable.subscribe(info => this.state.updateNewsInfo(info))
    return responseObservable
  }

  get_all_posts(page): Observable<any>{
    let headers=new Headers();
    headers.append('content-Type','application/json')
    const url_user = this.Url + '/stbetwebcms/?json=get_all_posts&page='+page;
    return this.http.get(url_user);
  }

  get_search(key): Observable<any>{
    const url_user = this.Url + '/stbetwebcms/?json=get_search&key='+key;
    return this.http.get(url_user);
  }

  //get racing paper
  get_racing_paper(): Observable<any>{

    let headers=new Headers();
    headers.append('content-Type','application/json')
    const url_user = this.Url + '/stbetwebcms/?json=get_racing_paper';
    return this.http.get(url_user);
  }

  get_home_banners(): Observable<any> {
    let headers = new Headers();
    headers.append('content-Type', 'application/json')
    return this.http.get(this.Url +'/stbetwebcms/?json=get_home_banners');
  }

}
